import React, { useState, useEffect } from "react";
import Lottie from "lottie-react";
import dropplyAnimation from "../../../Dropply_Logomotion.json";
import style from "./style.module.css";

type Props = {
  size?: "small" | "medium" | "large" | "fullscreen";
  className?: string;
  onComplete?: () => void; // Callback when loading completes
};

export default function Loading(props: Props) {
  const { size = "medium", className = "", onComplete } = props;
  const [showLoading, setShowLoading] = useState(true);
  
  const sizeClasses = {
    small: style.small,
    medium: style.medium,
    large: style.large,
    fullscreen: style.fullscreen,
  };

  useEffect(() => {
    // Run logo animation for exactly 6 seconds
    const timer = setTimeout(() => {
      setShowLoading(false);
      if (onComplete) {
        onComplete();
      }
    }, 6000); // 6 seconds

    return () => clearTimeout(timer);
  }, [onComplete]);

  // Always show loading initially
  if (!showLoading) {
    return null;
  }

  return (
    <div className={`${style.loadingContainer} ${sizeClasses[size]} ${className}`}>
      <Lottie 
        animationData={dropplyAnimation} 
        loop={true}
        autoplay={true}
        className={style.lottieAnimation}
      />
    </div>
  );
}
